import { setToken } from 'pobble-components/dist/auth-helpers'
import { redirectAfterAuth } from 'pobble-components/dist/auth-helpers'
import { getFinishSignupStatus } from '../../../../../common/api/me.selectors'
import EVENTS from '../../../../../events'
import { isRedirectAfterAuthTest } from '../../../../../common/redirect-after-auth-flag'

const finishSignin = (res, location, history) => {
  if (!res || !res.data || !res.data.jwt) return
  setToken(res.data.jwt)
  const FSUStatus = getFinishSignupStatus(res.data)

  EVENTS.onOauthSignin().then(() => {
    !FSUStatus.finished
      ? history.push('/finish-signup')
      : redirectAfterAuth(isRedirectAfterAuthTest())
  })
}

export { finishSignin }
